export const BASE_GAP_MULTIPLIER = 16;
